const Services = () => {
    return (
        <div>
            <h1>В процессе разработки</h1>
        </div>
    );
}

export default Services;